<template lang="pug">
    div.layoutWrapper

        v-carousel.carouselWrapper(hide-delimiters hide-controls height="auto" interval="5000")
            v-carousel-item(
                v-for="(item,i) in items"
                :key="i"
                :src="item.src"
                reverse-transition="fade"
                transition="fade"
            )

        div.content-wrapper
            div.content

                // Logo
                logo-component.logoWrapper(type="gympass")

                // Description
                div.description.text-center
                    // Title
                    h1.h1 {{ $t('auth.registrationByBusiness.title') }}

                    // Message
                    div.message(v-html="message")

                div.auth-form.c-form
                    // Registration form
                    registration-form(:businessId="businessId" :customFields="customFields" :isUkrainePage="isUkrainePage")

        // footer
        Footer.footerWrapper(v-if="$vuetify.breakpoint.mdAndUp")
</template>

<script>
    import RegistrationForm from './RegistrationForm';
    import Logo from '~components/Logo';
    import Footer from '../../Dashboard/Footer';
    import VueTypes from 'vue-types';

    export default {
        components: {
            LogoComponent: Logo,
            RegistrationForm: RegistrationForm,
            Footer
        },
        props: {
            message: VueTypes.string.def(''),
            businessId: VueTypes.string.def(''),
            customFields: VueTypes.array.def([])
        },
        computed: {
            isUkrainePage() {
                return (
                    this.businessId === process.env.VUE_APP_UKRAINE_BUSINESS_ID
                );
            },
            items() {
                if (this.isUkrainePage)
                    return [
                        {
                            src:
                                'https://s3.us-east-2.amazonaws.com/chillanywhere.com/ezgif-1-dff9851de7-min.jpeg'
                        },
                        {
                            src:
                                'https://s3.us-east-2.amazonaws.com/chillanywhere.com/auth-images/3-min.jpg'
                        },
                        {
                            src:
                                'https://s3.us-east-2.amazonaws.com/chillanywhere.com/pexels-photo-190340-min.jpeg'
                        }
                    ];
                return [
                    {
                        src:
                            'https://s3.us-east-2.amazonaws.com/chillanywhere.com/auth-images/1-min.jpg'
                    },
                    {
                        src:
                            'https://s3.us-east-2.amazonaws.com/chillanywhere.com/auth-images/3-min.jpg'
                    },
                    {
                        src:
                            'https://s3.us-east-2.amazonaws.com/chillanywhere.com/auth-images/3-min.jpg'
                    }
                ];
            }
        }
    };
</script>

<style lang="stylus" scoped>
        @import "../../../assets/style/_mixins.styl";
        @import "../../../assets/style/_variables.styl";

        .layoutWrapper
            position: relative
            min-height: 100vh
            display: flex
            flex-direction: column
            background-color: $theme.primary

        .carouselWrapper
            position: absolute
            top: 0
            left: 0
            bottom: 0
            right: 0
            width: 100%
            height: 100%
            z-index: 1

            &:after
                content: ''
                top: 0
                left: 0
                width: 100%
                height: 100%
                min-height: 100%
                position: absolute
                background: rgba(2,35,65,0.7)

        .fade-enter-active,
        .fade-leave-active,
        .fade-leave-to
            transition: .5s ease-out

        .fade-enter,
        .fade-leave,
        .fade-leave-to
            opacity: .8

        .content-wrapper
            display: flex
            justify-content: center
            padding-top: 50px
            padding-bottom: 50px
            min-height: calc(100vh - 111px)
            z-index: 2

        .footerWrapper
            padding-top: 15px
            z-index: 2

        .content
            width: 520px
            text-align: center

        .logoWrapper
            margin-bottom: 5rem
            text-align: center
            display: flex;
            align-items: center;
            justify-content: center;

        .auth-form
            margin: 0 auto
            width: 440px

        .description
            margin-top: 40px
            margin-bottom: 28px
            font-size: 14px
            color: $theme.white

        .h1
            margin-top: 3rem
            margin-bottom: 2rem
            padding-bottom: 0
            font-size: remify(50px)
            color: $theme.white
            font-weight: 300

        .message
            margin-bottom: 1rem
            font-size: remify(27px)
            font-weight: 300

    >>>
        .v-window__container
            height: 100% !important
            min-height: 100% !important

        .v-carousel__item
            height: 100% !important
            min-height: 100% !important

        .v-window-item
            height: 100% !important
            min-height: 100% !important

        @media screen and (max-width: $grid-breakpoints.md - 1)
            .content-wrapper
                height: 100%
                min-height: 100%

            .h1
                font-size: remify(36px)

            .message
                font-size: remify(24px)

        @media screen and (max-width: $grid-breakpoints.sm - 1)
            .content-wrapper
                flex: 1 1 auto
                padding-top: 10px

            .content
                width: 100%
                padding: 0 5px 20px

            .logoWrapper
                margin-bottom: 2rem

            .description
                margin-top: 0
                margin-bottom: 15px

            .auth-form
                width: 100%

            .h1
                margin-top: 1.5rem
                margin-bottom: 1rem
                font-size: remify(32px)

            .message
                font-size: remify(20px)
</style>
